import { locationHistoryInOutGeofence, previousAlertsInOutGeofence } from './detail-notification'

export const dataDemoGeneral = [
  {
    rawAlertId: 14,
    alertCode: 7,
    isResolved: null,
    alert: {
      alertCode: 7,
      descriptionEng: 'Enter Geofence Pasar Dharma Tanjung',
      descriptionIdn: 'Masuk Geolokasi Pasar Dharma Tanjung',
      fullDescriptionEng: 'Entering / Exiting geolocation',
      fullDescriptionIdn: 'Keluar / Masuk geolokasi',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      alertCategories: [
        {
          alertCategoryId: 1,
          __typename: 'AlertCategory',
        },
      ],

      alertData: '89|300|9216.0100',
      __typename: 'AlertCode',
    },
    driver: null,
    driverId: null,
    createdOn: '2025-09-03T05:42:38.000Z',
    alertTrigger: 160,
    alertFlag: false,
    alertData: '193538',
    vehicle: {
      id: 33353,
      licensePlate: 'Demo F',
      imei: '864032050001849',
      device: {
        phoneNo: '081130531502',
        deviceCode: 6001,
        __typename: 'Device',
      },
      vehicleType: {
        category: 'Trailer',
        icon: 'bigTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3',
          __typename: 'SensorResponseType2',
        },
      ],
      __typename: 'Vehicle',
    },
    formattedAlertData: '',
    longitude: 113.397493,
    latitude: -7.217438,
    geofence: '-',
    additionalData: {
      downloadVideoStatus: 'S',
      __typename: 'AdditionalData',
    },
    isImportant: null,
    isUrgent: null,
    isRead: null,
    lastUserFeedback: null,
    vehicleId: 33353,
    readOn: null,
    geofences: [],
    resolvedOn: null,
    resolvedBy: null,
    resolver: null,
    userLogs: [],
    isFalseAlert: null,
    locationHistory: locationHistoryInOutGeofence,
    previousAlerts: previousAlertsInOutGeofence,
    media: [
      {
        downloadId: 1,
        identifier: 'P',
        mediaFilename: 'in-geofence-picture-kamera1.png',
        channel: 1,
        status: 'S',
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
      {
        downloadId: 2,
        identifier: 'P',
        mediaFilename: 'in-geofence-picture-kamera2.png',
        channel: 2,
        status: 'S',
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
      {
        downloadId: 3,
        identifier: 'P',
        mediaFilename: 'in-geofence-picture-kamera3.png',
        channel: 3,
        status: 'S',
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
      {
        downloadId: 4,
        identifier: 'V',
        mediaFilename: 'in-geofence-video-kamera1.mp4',
        channel: 1,
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
      {
        downloadId: 5,
        identifier: 'V',
        mediaFilename: 'in-geofence-video-kamera2.mp4',
        channel: 2,
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
      {
        downloadId: 6,
        identifier: 'V',
        mediaFilename: 'in-geofence-video-kamera3.mp4',
        channel: 3,
        downloadOn: '2025-09-03T07:53:51.000Z',
      },
    ],
    mediaStatus: 'Success',
    statusText: '1,2,3,4',
    __typename: 'RawAlert',
  },
]
